import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { coesMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { DynamicCustomFiltersProps } from '../../../../../../../../store/product/types';
import { transformCustomCategories, transformCustomFilters } from '../../../../constants';
import { OperationType } from '../../../../contexts/constants';
import { AssetCaptionType } from '../../../AssetCaptions';
import {
  coesApplicationAmountFilter,
  coesRisk,
  daysToRedemptionFilter,
} from '../../../AssetFilters/constants';
import { AssetNoticesNormalized } from '../../../AssetNotices';
import { onlyHighRiskInvestorsNoticeCoes } from '../../../AssetNotices/constants';

import { CoesAsset } from '.';

export const coesTableHead: TableHeadItemRecurse[] = [
  // { title: 'Risco', orderValue: 'riskRatingLevel' }, // Currently not working
  { title: 'Vencimento', orderValue: 'maturityDate' },
];

export const coesConstants = {
  id: 'coes',
  typeGetterId: 'coes',
  title: 'Operações Estruturadas',
  operationId: 1,
  operationName: 'Compra',
  operationType: 'buy' as OperationType,
  color: 'product.estruturados' as ColorTypes.Option,
  principalComponent: CoesAsset,
  tableHead: coesTableHead,
  hideTableHead: true,
  marketStatusSelector: coesMarketStatusQuery,
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [
      coesRisk,
      ...transformCustomFilters(customFilters),
      coesApplicationAmountFilter,
      daysToRedemptionFilter,
    ];
  },
  hasCategories: true,
  categoriesLabel: 'Estratégia',
  categoriesField: 'strategy',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'strategy'),
  captions: [] as AssetCaptionType[],
  groupNotices: true,
  notices: [onlyHighRiskInvestorsNoticeCoes] as AssetNoticesNormalized[],
  hasRefresher: false,
  unleashFlag: Constant.UnleashToggleStructuredOperations,
  unleashFlagBatchTicket: Constant.UnleashBasketStructuredOperationsToggle,
  unleashFlagCustomers: Constant.UnleashCustomersStructuredOperationsToggle,
} as const;
